/**
 * Step 7 — Health Thresholds
 *
 * Focuses solely on the Thresholds tab from Project Settings.
 * RAG thresholds for financial health, schedule, and WIP.
 */

import { StepWrapper } from '../StepWrapper';
import SettingsProject from '@/pages/settings-project';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step7Thresholds({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  return (
    <StepWrapper
      barState="default"
      barMessage="These thresholds drive the RAG health indicators shown on every project, the Finance Dashboard, and WIP reports."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-foreground">Health Thresholds</h2>
        <p className="text-sm text-muted-foreground mt-0.5">
          Define the amber and red thresholds for financial health, schedule performance, and aged WIP across all projects.
        </p>
      </div>
      <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
        <SettingsProject defaultTab="thresholds" />
      </div>
    </StepWrapper>
  );
}
